/**
 * @generated SignedSource<<d108a9e5c54850b7a630cc9e3b02c39f>>
 * @relayHash 61d1febca05be797fffaa99cf502f29d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 61d1febca05be797fffaa99cf502f29d

import { ConcreteRequest } from 'relay-runtime';
export type chCallButtonQuery$variables = {
  id: string;
};
export type chCallButtonQuery$data = {
  readonly callLineInformation: {
    readonly callLine: string;
    readonly isRecorded: boolean;
  };
};
export type chCallButtonQuery = {
  response: chCallButtonQuery$data;
  variables: chCallButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": "callLineInformation",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CallLineOutput",
    "kind": "LinkedField",
    "name": "ch_callLineInformationByPatientId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callLine",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRecorded",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chCallButtonQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chCallButtonQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "61d1febca05be797fffaa99cf502f29d",
    "metadata": {},
    "name": "chCallButtonQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "903ada813bb47d07ec26c7102162e25d";

export default node;
